import { useQuery } from "@/compat/reactQuery";
import queryKeys from "../../../constants/queryKeys";
import templateService from "../../services/templateService";

const useAllModuleEnabledTemplates = ({ moduleArea, accountId, siteExternalIds, includeDisabled = false }) =>
    useQuery(
        [queryKeys.templates, moduleArea, accountId, siteExternalIds?.join(",")],
    () =>
      templateService.fetchAllTemplatesForModule({
        moduleArea,
        accountId,
        siteExternalIds,
        includeDisabled         
      }), 
        {
            // Gate only on having sites (matches the non-user sibling hook).
            // Previously also gated on `!!includeDisabled`, which conflated
            // "include disabled templates" with "run the query" — callers worked
            // around it by passing the truthy STRING "false", so a real boolean
            // `false` would wrongly disable the query.
            enabled: !!siteExternalIds?.length
        }
  );

  

export default useAllModuleEnabledTemplates;
